import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-logout-redirect',
    template: ''
})

export class RedirectLogoutComponent implements OnInit  {

    constructor() { }

    ngOnInit(): void {
        localStorage.clear();
    }
}
